import { FilterItem } from "src/app/settings/models/filter-item";

export const ERRORSTATES: FilterItem[] = [
  { displayName: 'Missing Product', value: 'productError', isSelected: false, isEnabled: true },
  { displayName: 'Agreement Mapping', value: 'agreementError', isSelected: false, isEnabled: true }
]